(function () {

  angular
    .module('meanApp')
    .directive('recipeThumb', recipeThumb);

  function recipeThumb () {
    return {
      restrict: 'E',
      replace: true,
      scope : {
        'recipe': '=',
        'size' : '@'
      },
      templateUrl: '/common/directives/recipeThumb/recipeThumb.template.html'
    };
  }

})();